import { useUserStore } from '@/stores/user';
import { decodeState } from '../util/state-utils.js';

export const RedirectFlowMixin = {
  methods: {
    /**
     * Handles redirect flow from host mismatch in connector service
     * Checks for redirect_source query parameter and handles authentication accordingly
     */
    async handleRedirectFlow() {
      const redirectSource = this.$route.query['redirect_source'];
      let emailFromState = null;
      let asuriteIdFromState = null;

      // Check for encoded state data and decode it
      const encodedState = this.$route.query['state'] || localStorage.getItem('login_state');

      if (encodedState) {
        try {
          const stateData = decodeState(encodedState);
          this.logInfo('Decoded state data', stateData);

          // Get email and asurite_id from state data only
          emailFromState = stateData.email;
          asuriteIdFromState = stateData.asurite_id && stateData.asurite_id !== 'null' && stateData.asurite_id !== null;
        } catch (error) {
          this.logError('Failed to decode state data', error);
        }
      }

      this.logInfo('Handling redirect flow', { redirectSource, emailFromState, asuriteIdFromState });

      // Pre-fill email if provided in state data and email field exists
      if (emailFromState && this.email !== undefined) {
        this.email = emailFromState;
      }

      // If emailFromState is an ASU email, redirect to ASURITE sign-in
      if ((emailFromState && emailFromState.toLowerCase().endsWith('@asu.edu')) || asuriteIdFromState) {
        this.logInfo('ASU email detected, proceeding with ASURITE login');

        // for smooth UX, wait a bit before redirecting
        await new Promise((resolve) => setTimeout(resolve, 500));

        this.$auth.login('asurite');

        return;
      }

      // Check if partner is eligible for sign up
      const userStore = useUserStore();
      const isEligibleForSignUp = userStore.welcomePageData.isEligibleForSignUp;

      if (!isEligibleForSignUp) {
        // If not eligible for sign up, do ASURITE login
        this.logInfo('Partner not eligible for sign up, proceeding with ASURITE login');

        await new Promise((resolve) => setTimeout(resolve, 500));

        this.$auth.login('asurite');

        return;
      } else if (emailFromState) {
        // If eligible for sign up and email is provided, do custom OAuth
        this.logInfo('Partner eligible for sign up with email, proceeding with custom OAuth');

        await new Promise((resolve) => setTimeout(resolve, 500));

        this.$auth.login('custom_oauth', { email: emailFromState });

        return;
      }

      // Clean up URL by removing query parameters
      this.$router.replace({ path: this.$route.path, query: {} });
      this.logInfo('Redirect flow completed, query parameters cleared');
    },

    /**
     * Checks if current route has redirect_source query parameter
     * @returns {boolean} true if redirect_source exists in query params
     */
    hasRedirectSource() {
      return this.$route.query && this.$route.query['redirect_source'];
    }
  }
};
